import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { designer, navLinks, ui } from '../data/mock';

const Footer = () => {
  return (
    <footer className="px-8 md:px-[90px] pt-24 pb-10 border-t border-[var(--cream)]/10" style={{ background: 'var(--bg-dark)' }}>
      <div className="grid md:grid-cols-12 gap-10 mb-20">
        <div className="md:col-span-6">
          <div className="font-label text-[0.7rem] text-[var(--terracotta)] mb-6">
            ——  Kom i kontakt
          </div>
          <a
            href={`mailto:${designer.email}`}
            className="font-display text-[clamp(2rem,5vw,4rem)] text-[var(--cream)] hover:text-[var(--terracotta)] transition-colors duration-500 inline-flex items-center gap-4 group break-all"
          >
            <span>{designer.email}</span>
            <ArrowUpRight
              size={28}
              className="transition-transform duration-500 group-hover:rotate-45 shrink-0"
            />
          </a>
          <a
            href={designer.phoneHref}
            className="mt-6 font-heading text-base text-[var(--cream)]/60 hover:text-[var(--terracotta)] transition-colors duration-300 inline-block"
          >
            {designer.phone}
          </a>
        </div>
        <div className="md:col-span-3">
          <div className="font-label text-[0.66rem] text-[var(--cream)]/40 mb-5">{ui.navigate}</div>
          <ul className="space-y-3">
            {navLinks.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="font-heading text-[var(--cream)] hover:text-[var(--terracotta)] transition-colors duration-300 text-base"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="font-label text-[0.66rem] text-[var(--cream)]/40 mb-5">{ui.elsewhere}</div>
          <ul className="space-y-3">
            <li>
              <a
                href={designer.linkedIn}
                target="_blank"
                rel="noopener noreferrer"
                className="font-heading text-[var(--cream)] hover:text-[var(--terracotta)] transition-colors duration-300"
              >
                LinkedIn
              </a>
            </li>
            <li>
              <a
                href={designer.instagramURL}
                target="_blank"
                rel="noopener noreferrer"
                className="font-heading text-[var(--cream)] hover:text-[var(--terracotta)] transition-colors duration-300"
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                href={`mailto:${designer.email}`}
                className="font-heading text-[var(--cream)] hover:text-[var(--terracotta)] transition-colors duration-300"
              >
                Email
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="pt-10 border-t border-[var(--cream)]/10">
        <div className="font-display text-[clamp(1.4rem,4vw,3rem)] text-[var(--cream)]/15 leading-none select-none mb-8 whitespace-nowrap">
          {designer.wordmark}
        </div>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 font-label text-[0.62rem] text-[var(--cream)]/40">
          <span>© {new Date().getFullYear()}</span>
          <span aria-hidden="true">·</span>
          <span>{designer.location}</span>
          <span aria-hidden="true">·</span>
          <span>Alle rettigheder forbeholdes</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
